import { z } from 'zod';
import { GameMeta } from './games.js';
export const Wallet = z.object({
    balance: z.number().int().nonnegative(),
    currency: z.literal('coins'),
});
export const MarqueeItem = z.object({
    id: z.string(),
    text: z.string(),
    kind: z.enum(['big_win', 'system', 'event']),
});
export const DailyBonus = z.object({
    available: z.boolean(),
    amount: z.number().int().nonnegative(),
    next_claim_at: z.string().nullable(),
});
export const HomeResponse = z.object({
    user: z.object({
        user_id: z.string(),
        display_name: z.string(),
        avatar_url: z.string().nullable(),
    }),
    wallet: Wallet,
    games: z.array(GameMeta),
    marquee: z.array(MarqueeItem),
    daily_bonus: DailyBonus,
});
//# sourceMappingURL=home.js.map